import React from "react";
import { ISVG } from "./interface";

const SVG: React.FC<ISVG> = ({
  style = {},
  fill = "var(--tlx-surface-bg-surface)",
  width = 20,
  height = 20,
  className = "",
  viewBox,
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    viewBox={viewBox || "0 0 20 20"}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    fill="none"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M9.8 10.9961C8.90313 10.9961 8.47187 11.4961 7 11.4961C5.52813 11.4961 5.1 10.9961 4.2 10.9961C1.88125 10.9961 0 12.8773 0 15.1961V16.4961C0 17.3242 0.671875 17.9961 1.5 17.9961H12.5C13.3281 17.9961 14 17.3242 14 16.4961V15.1961C14 12.8773 12.1188 10.9961 9.8 10.9961ZM13 16.4961C13 16.7711 12.775 16.9961 12.5 16.9961H1.5C1.225 16.9961 1 16.7711 1 16.4961V15.1961C1 13.4305 2.43437 11.9961 4.2 11.9961C4.8125 11.9961 5.42188 12.4961 7 12.4961C8.575 12.4961 9.1875 11.9961 9.8 11.9961C11.5656 11.9961 13 13.4305 13 15.1961V16.4961ZM7 9.99609C9.20937 9.99609 11 8.20547 11 5.99609C11 3.78672 9.20937 1.99609 7 1.99609C4.79063 1.99609 3 3.78672 3 5.99609C3 8.20547 4.79063 9.99609 7 9.99609ZM7 2.99609C8.65313 2.99609 10 4.34297 10 5.99609C10 7.64922 8.65313 8.99609 7 8.99609C5.34687 8.99609 4 7.64922 4 5.99609C4 4.34297 5.34687 2.99609 7 2.99609Z"
      fill="var(--tlx-cta-primary-default)"
    />
    <circle cx="13" cy="14.998" r="5" fill="var(--tlx-surface-bg-surface)" />
    <g clipPath="url(#clip0_5586_34202)">
      <path
        d="M13.0007 10.8311C15.3019 10.8311 17.1673 12.6965 17.1673 14.9977C17.1673 17.299 15.3019 19.1644 13.0007 19.1644C10.6994 19.1644 8.83398 17.299 8.83398 14.9977C8.83398 12.6965 10.6994 10.8311 13.0007 10.8311ZM13.0007 12.9144C12.9251 12.9144 12.8522 12.9417 12.7953 12.9914C12.7384 13.041 12.7013 13.1096 12.6911 13.1844L12.6882 13.2269V14.6852H11.2298C11.1506 14.6852 11.0744 14.7153 11.0166 14.7694C10.9587 14.8234 10.9235 14.8974 10.9181 14.9764C10.9127 15.0554 10.9375 15.1335 10.9875 15.1949C11.0375 15.2563 11.1089 15.2965 11.1873 15.3073L11.2298 15.3102H12.6882V16.7686C12.6882 16.8477 12.7183 16.9239 12.7723 16.9818C12.8264 17.0397 12.9004 17.0748 12.9794 17.0802C13.0583 17.0856 13.1364 17.0608 13.1979 17.0109C13.2593 16.9609 13.2994 16.8895 13.3102 16.8111L13.3132 16.7686V15.3102H14.7715C14.8507 15.3102 14.9269 15.2801 14.9847 15.2261C15.0426 15.172 15.0778 15.098 15.0832 15.019C15.0886 14.94 15.0638 14.8619 15.0138 14.8005C14.9638 14.7391 14.8924 14.6989 14.814 14.6881L14.7715 14.6852H13.3132V13.2269C13.3132 13.144 13.2802 13.0645 13.2216 13.0059C13.163 12.9473 13.0835 12.9144 13.0007 12.9144Z"
        fill="var(--tlx-cta-primary-default)"
      />
    </g>
    <defs>
      <clipPath id="clip0_5586_34202">
        <rect
          width="10"
          height="10"
          fill={fill}
          transform="translate(8 9.99805)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default SVG;
